import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=5e7e678a&scoped=true&"
import script from "./TransactionsHistory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TransactionsHistory.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TransactionsHistory.vue?vue&type=style&index=0&id=5e7e678a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7e678a",
  null
  
)

export default component.exports